module.exports = __webpack_public_path__ + "img/9-2.2df1f8f5.jpg";